// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.term-content[data-v-345c12c9] {\n    font-size: 14px;\n    line-height: 1.6;\n}\n.term-content[data-v-345c12c9] p {\n    margin-bottom: 1em;\n}\n.term-content[data-v-345c12c9] ul,\n.term-content[data-v-345c12c9] ol {\n    margin-bottom: 1em;\n    padding-left: 2em;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
